const menuInit = () => {
  const navMenu = document.getElementById('js-aside')
  const navOpen = document.getElementById('js-aside-open')
  const navClose = document.getElementById('js-aside-close')

  if (!navOpen || !navClose || !navMenu) return

  navOpen.addEventListener('click', () => {
    navMenu.setAttribute('aria-disabled', false)
  })

  navClose.addEventListener('click', () => {
    navMenu.setAttribute('aria-disabled', true)
  })
}

export default menuInit
